import {
  setUser as setSentryUser,
  addBreadcrumb as addSentryBreadcrumb,
  setContext as setSentryContext,
  setTag as setSentryTag,
  type SeverityLevel,
} from '@sentry/react';
import { getLogger } from './instance';

interface DatadogUser {
  id: string;
  email: string;
  name: string;
}

interface DatadogExperiment {
  id: number;
  variant: number;
}

export function log(
  message: string,
  data: Record<string, unknown>,
  status: 'info' | 'error' | 'warn' = 'info'
) {
  getLogger().log(message, { data }, status);

  if (process.env.PUBLIC_ENABLE_CONSOLE_LOGS === 'true') {
    // eslint-disable-next-line no-console -- allow console logging
    console.log(message, { data, status });
  }

  let sentryLevel: SeverityLevel = 'info';
  if (status === 'error') {
    sentryLevel = 'error';
  } else if (status === 'warn') {
    // DD uses `warn`, Sentry uses `warning`
    sentryLevel = 'warning';
  }

  addSentryBreadcrumb({
    message,
    data,
    level: sentryLevel,
  });
}

export function setUser(user: DatadogUser) {
  getLogger().setContextProperty('user', user);

  const { id } = user;
  setSentryUser({
    id,
  });
}

export function setExperiments(experiments: DatadogExperiment[]) {
  const experimentsMap = experiments.reduce(
    (seed, experiments) => {
      seed[experiments.id] = experiments.variant.toString();
      return seed;
    },
    {} as Record<string, string>
  );

  getLogger().setContextProperty('experiments', experimentsMap);
  setSentryContext('experiments', experimentsMap);

  // Trying out experiment tags to allow filtering by experiments in Sentry.
  // Add experiments as needed as adding too many can decrease performance.
  setSentryTag('exp_171', experimentsMap[17100]);
}
